import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=e068bbbe&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PageLoader.vue?vue&type=style&index=0&id=e068bbbe&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e068bbbe",
  null
  ,true
)

export default component.exports